import React, { useState, useEffect } from 'react';
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import InfoIcon from "@mui/icons-material/Info";
import Typography from "@mui/material/Typography";
import { getCategoryGraph, clearCategoryGraph } from "../../../actions/categoryTemplateActions";
import { expanderClear } from "../../../actions/expanderActions";
import ArgoReviewTemplateHook from "../../common/ArgoReviewTemplateHook";
import GroupViewerExpandableHook from "../groups/GroupViewerExpandableHook";
import ArgoPortalPreviewHook from "../../common/ArgoPortalPreviewHook";
import statusFormatter from "../../../utilities/StatusFormatter";
import * as metadataUtils from "../../../utilities/metadata";
import * as TEMPLATE from "../../../constants/templateConstants";
import * as portalShared from "../../../portal/shared/metadataConstantsAndUtilities"
import {addDrawerNameToStack, removeDrawerNameToStack} from "../../../actions/drawerStackAction";
import FlagCircleIcon from "@mui/icons-material/FlagCircle";


const CategoryReviewHook = (props) => {
    const {
        //templateKey,
        templateId,
        selectedTemplate,
        selectedTemplateIsGraph,
        setStateCallBack,
        scrollTo,
        width,
    } = props;

    const [state, setState] = useState({
        expandAll: true,
        openGroupReview: false,
        selectedGroupInfoKey: "",
        selectedGroupInfoId: "",
        selectedGroupInfoTemplate: {},
        openQuestionReview: false,
        selectedQuestionInfoKey: "",
        selectedQuestionInfoId: "",
        selectedQuestionInfoTemplate: {},
        //groupsLoaded: false,
        //categoryTemplates: {},
        showCategoryBackButton: true,
        showGroupBackButton: true,
        initialScroll: false,
    });

    const dispatch = useDispatch();

    const fromStoreCategoryTemplateGraph = useSelector(state => state.categoryTemplateGraph);

    const [categoryTemplate, setCategoryTemplate] = useState({});
    const [categoryTemplateGraph, setCategoryTemplateGraph] = useState({});

    // ComponentWillMount equivalent
    useEffect(() => {
        dispatch(addDrawerNameToStack("Review", "Category"))

        // componentWillUnmount equivalent
        return () => {
            dispatch(expanderClear("CategoryReview"));
            dispatch(clearCategoryGraph());
            dispatch(removeDrawerNameToStack())
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);


    // componentDidMount equivalent
    useEffect(() => {

        if ((selectedTemplateIsGraph && selectedTemplate["id"]) || fromStoreCategoryTemplateGraph["id"]) {
            let categoryGraphClone = portalShared.cloneObj(selectedTemplateIsGraph ? selectedTemplate : fromStoreCategoryTemplateGraph);
            let groupKeysArray = [];
            let groupTemplatesObj = {};
            for (let g = 0; g < categoryGraphClone.groupTemplates.length; g++) {
                groupKeysArray.push(categoryGraphClone.groupTemplates[g]);
                groupTemplatesObj[categoryGraphClone.groupTemplates[g].templateKey] = categoryGraphClone.groupTemplates[g];
            }

            // setGroupKeys(groupKeysArray);
            // setGroupTemplates(groupTemplatesObj);

            categoryGraphClone.groupKeys = groupKeysArray; // Add groupKeys array to graph
            setCategoryTemplate(categoryGraphClone);

            setCategoryTemplateGraph(categoryGraphClone);

        }
        else if (templateId)
        {
                dispatch(getCategoryGraph(templateId));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [templateId, selectedTemplateIsGraph, selectedTemplate, fromStoreCategoryTemplateGraph]);

    // Handle initial scroll
    useEffect(() => {

        if (!state.initialScroll) {
            const page = document.getElementById(scrollTo);
            if (page) {
                page.scrollIntoView({ block: 'end',  behavior: 'smooth' });
                setState(prevState => ({
                    ...prevState,
                    initialScroll: true
                }));
            }
        }
    }, [scrollTo, state.initialScroll]);

    const handleToolbarButtonClick = (event, fieldName, buttonTitle) => {
        if (buttonTitle === 'BACK') {
            setState(prevState => ({
                ...prevState,
                openGroupReview: false,
                openQuestionReview: false,
                showCategoryBackButton: true
            }));
        }
    };

    const setStateCallback = (stateObj) => {
        setState(prevState => ({
            ...prevState,
            ...stateObj
        }));
    };

    const standardStyle = {
        width: "100%",
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        overflowWrap: "break-word"
    };

    // Clone template for consistency with original component
    let templateClone = {};

    if (categoryTemplate["id"]) {
        templateClone = portalShared.cloneObj(categoryTemplate);
    }
    // else if (template && template.hasOwnProperty("id") && template.id === parseInt(templateId)) {
    //     templateClone = {...template};
    // }

    // Pass state up to parent if needed
    setStateCallBack({ showCategoryBackButton: state.showCategoryBackButton });
    
    const metadata = templateClone?.metadata;

    if (state.openGroupReview) {

        return <ArgoReviewTemplateHook
            templateType={TEMPLATE.TYPE.GROUP}
            templateKey={state.selectedGroupInfoKey}
            templateId={state.selectedGroupInfoId}
            templateObject={state.selectedGroupInfoTemplate}
            handleToolbarButtonClickFunction={handleToolbarButtonClick}
            width={width}
        />;
    }

    if (state.openQuestionReview) {

        return <ArgoReviewTemplateHook
            templateType={TEMPLATE.TYPE.QUESTION}
            templateKey={state.selectedQuestionInfoKey}
            templateId={state.selectedQuestionInfoId}
            templateObject={state.selectedQuestionInfoTemplate}
            handleToolbarButtonClickFunction={handleToolbarButtonClick}
            width={width}
        />;
    }

    let current = true
    if (fromStoreCategoryTemplateGraph?.groupTemplates) {
        current = fromStoreCategoryTemplateGraph?.groupTemplates.every(group =>
            group.currentFlag !== false &&
            group.questionTemplates.every(question =>
                question.currentFlag !== false
            )
        );
    }

    return (
        <div id="CategoryReview-container-div">
            {templateClone.hasOwnProperty("metadata") ?
                <div id="CategoryReview-inner-container-div" style={{ flexGrow: "2", padding: "32px" }}>
                    <div style={{ minHeight: "min-content" }}>

                        <Typography variant="h6" component="div">
                            Category Information:
                        </Typography>

                        <div>&nbsp;</div>

                        <div id="CategoryReview-type-container-div" style={standardStyle}>
                            <div style={{color: portalShared.LABEL_COLOR}}>Status:</div>
                            <div>&nbsp;</div>
                            <div>{statusFormatter(templateClone, 0, 0, true, true)}</div>
                            <div>&nbsp;&nbsp;</div>
                            <div style={{
                                color: "red",
                                fontSize: "12px",
                                paddingTop: "2px"
                            }}>{templateClone.currentFlag ? "" : "(Not Current Version)"}</div>
                        </div>

                        <div>&nbsp;</div>

                        {!current ?
                            <React.Fragment>
                                <div style={{display: "flex"}}>
                                    <FlagCircleIcon style={{color: "#E84343"}}/>
                                    <div>&nbsp;</div>
                                    <div style={{color: portalShared.colorNameToHex('red')}}>Not all components are current. To update components, republish questionnaire</div>
                                </div>

                                <div>&nbsp;</div>
                            </React.Fragment> : ""
                        }

                        <div id="CategoryReview-portal-page-break-container-div" style={standardStyle}>
                            <div style={{ color: portalShared.LABEL_COLOR }}>Portal Page Break:</div>
                            <div>&nbsp;</div>
                            <div>{metadata[portalShared.CUSTOM_DDO_CAT_FORMAT] ? (JSON.parse(metadata[portalShared.CUSTOM_DDO_CAT_FORMAT]).portalPageBreak ? 'Yes' : 'No') : 'No'}</div>
                        </div>

                        <div>&nbsp;</div>

                        <div id="CategoryReview-title-bar-container-div" style={standardStyle}>
                            <div style={{ color: portalShared.LABEL_COLOR }}>Portal Title Bar:</div>
                            <div>&nbsp;</div>
                            <div>{metadata[portalShared.CUSTOM_DDO_CAT_FORMAT] ? (JSON.parse(metadata[portalShared.CUSTOM_DDO_CAT_FORMAT]).titlebar ? 'Yes' : 'No') : 'No'}</div>
                        </div>

                        <div>&nbsp;</div>

                        <div id="CategoryReview-name-container-div" style={standardStyle}>
                            <div style={{ color: portalShared.LABEL_COLOR }}>Category:</div>
                            <div>&nbsp;</div>
                            <div>{templateClone.name}</div>
                        </div>

                        <div>&nbsp;</div>

                        <div id="CategoryReview-qualifier-container-div" style={standardStyle}>
                            <div style={{ color: portalShared.LABEL_COLOR }}>Qualifier:</div>
                            <div>&nbsp;</div>
                            <div>{templateClone.nameQualifier}</div>
                        </div>

                        <div>&nbsp;</div>

                        <div id="CategoryReview-description-container-div" style={standardStyle}>
                            <div style={{ color: portalShared.LABEL_COLOR }}>Description:</div>
                            <div>&nbsp;</div>
                            <div>
                                {templateClone.description && <div style={standardStyle}>
                                    <InfoIcon style={{ minWidth: "36px" }} />
                                    <div>&nbsp;</div>
                                    <div>{templateClone.description}</div>
                                </div>}
                            </div>
                        </div>

                        <div>&nbsp;</div>

                        <div>
                            {metadataUtils.listMetadata(templateClone, "Category")}
                        </div>
                    </div>

                    {/*// ===========================================================================================================*/}
                    {/*// ASSIGNED GROUPS LIST */}
                    {/*// ===========================================================================================================*/}

                    <GroupViewerExpandableHook
                        parentName="CategoryReview"
                        parentKey=""
                        categoryTemplate={templateClone}
                        groupKeys={templateClone.groupKeys}
                        showIconButtonReorder={false}
                        showIconButtonEdit={false}
                        showIconButtonRemove={false}
                        setStateCallback={setStateCallback}
                        hidePortalPreview={true}
                        useGraph={true}
                        categoryGraph={categoryTemplateGraph}
                    />

                    {/*// ===========================================================================================================*/}
                    {/*// RELATED SHOW GROUPS LIST */}
                    {/*// ===========================================================================================================*/}

                    <GroupViewerExpandableHook
                        parentName="CategoryReview"
                        parentKey=""
                        categoryTemplate={templateClone}
                        groupKeys={templateClone.groupKeys}
                        showIconButtonReorder={false}
                        showIconButtonEdit={false}
                        showIconButtonRemove={false}
                        setStateCallback={setStateCallback}
                        hidePortalPreview={true}
                        useGraph={true}
                        categoryGraph={categoryTemplateGraph}
                        isShowGroups={true}
                    />

                    {/*// ===========================================================================================================*/}
                    {/*// CATEGORY PORTAL PREVIEW */}
                    {/*// ===========================================================================================================*/}

                    <div id="CategoryReview-space-above-portal-preview" style={{ height: "20px" }}>&nbsp;</div>

                    <ArgoPortalPreviewHook
                        calledBy="CategoryReview"
                        templateType={TEMPLATE.TYPE.CATEGORY_GRAPH}
                        template={categoryTemplateGraph}
                        templateGraph={categoryTemplateGraph}
                    />

                </div>
                : ""
            }
        </div>
    );
};

CategoryReviewHook.defaultProps = {
    setStateCallBack: function () {},
    scrollTo: "",
    width: "100%",
    categoryTemplates: {},
    selectedTemplate: {},
    selectedTemplateIsGraph: false
};

CategoryReviewHook.propTypes = {
    templateKey: PropTypes.string,
    templateId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    selectedTemplate: PropTypes.object,
    selectedTemplateIsGraph: PropTypes.bool,
    categoryTemplates: PropTypes.object,
    setStateCallBack: PropTypes.func,
    scrollTo: PropTypes.string,
    width: PropTypes.string
};

export default CategoryReviewHook;